// menuData.js
import { UserOutlined } from '@ant-design/icons';
import { IoClipboardOutline } from 'react-icons/io5';
import { Avatar } from 'antd';
import { useAuth } from './contexts/AuthContext';
import { CiCircleCheck } from 'react-icons/ci';
import { GrDocumentStore } from 'react-icons/gr';
import { IoChatboxEllipsesOutline } from 'react-icons/io5';
import { IoMdSearch } from 'react-icons/io';
import { CiUser } from "react-icons/ci";
import { IoCartOutline } from "react-icons/io5";



// Supondo que `userImage` e outras variáveis dinâmicas sejam gerenciadas aqui ou passadas de alguma forma

export const useMenuData = () => {
  const { user } = useAuth();
  const userImage = null;

  const menuData = [

    {
      key: 'linhaProdutos',
      icon: (
        <IoCartOutline style={{fontSize: '24px'}} />
      ),
      title: 'Produtos',
      to: '/',
      isVisible: true,
      // hasDividerBefore: true,
      requiredUserLevel: 3,
    },

    {
      key: 'contatos',
      icon: (
        <CiUser style={{fontSize: '24px'}}/>
      ),
      title: 'Contatos',
      to: '/contatos',
      isVisible: true,
      hasDividerBefore: true,
      requiredUserLevel: 3,
    },
  ];

  return menuData;
};
